export default __webpack_public_path__ + "static/media/product-image-hover-5.f2b264ee.jpg";